import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import Cookies from "js-cookie";
const IoArrowBack = require("react-icons/io5").IoArrowBack;

const AdminStafDetail = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const token = Cookies.get("token");

  const [loading, setLoading] = useState(true);
  const [admin, setAdmin] = useState<any>(null);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [noTlpn, setNoTlpn] = useState("");
  const [role, setRole] = useState("");
  const [isConfirm, setIsConfirm] = useState<0 | 1>(0);

  const [fotoProfile, setFotoProfile] = useState<File | null>(null);
  const [fotoKtp, setFotoKtp] = useState<File | null>(null);
  const [fotoIdcard, setFotoIdcard] = useState<File | null>(null);

  // fetch detail
  useEffect(() => {
    const fetchAdmin = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/adminstaf/${id}`, { headers: { Authorization: `Bearer ${token}` } });
        const data = res.data;
        setAdmin(data);
        setName(data.name || "");
        setEmail(data.email || "");
        setNoTlpn(data.no_tlpn || "");
        setRole(data.role || "");
        setIsConfirm(data.is_confirm ?? 0); // set dari backend
      } catch (err) {
        console.error("Gagal fetch detail:", err);
        alert("Gagal memuat data admin staf.");
      } finally {
        setLoading(false);
      }
    };
    fetchAdmin();
  }, [id, token]);

  // handle update
  const handleUpdate = async (e: React.FormEvent) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("_method", "PUT"); // override jadi PUT
    formData.append("name", name);
    formData.append("email", email);
    formData.append("no_tlpn", noTlpn);
    formData.append("role", role);
    formData.append("is_confirm", isConfirm.toString());

    if (fotoProfile) formData.append("foto_profile", fotoProfile);
    if (fotoKtp) formData.append("foto_ktp", fotoKtp);
    if (fotoIdcard) formData.append("foto_idcard", fotoIdcard);

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/adminstaf/register/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      alert("Data admin staf berhasil diperbarui!");
      navigate("/dashboard/adminstaf");
    } catch (err) {
      console.error("Gagal update:", err);
      alert("Gagal memperbarui data.");
    }
  };

  if (loading)
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-primary"></div>
      </div>
    );
  if (!admin) return <p>Data tidak ditemukan.</p>;

  return (
    <div className="mt-6 max-w-2xl mx-auto border rounded-sm shadow-sm p-4">
      <Link to="/dashboard/akun">
        <div className="flex items-center gap-3 mb-4">
          <IoArrowBack />
          <h1 className="text-xl font-bold">Edit Data Admin Staf</h1>
        </div>
      </Link>

      <form onSubmit={handleUpdate} className="space-y-4">
        <div>
          <label className="block font-semibold">Nama</label>
          <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="w-full border px-3 py-2 rounded" />
        </div>

        <div>
          <label className="block font-semibold">Email</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border px-3 py-2 rounded" />
        </div>

        <div>
          <label className="block font-semibold">No Telepon</label>
          <input type="text" value={noTlpn} onChange={(e) => setNoTlpn(e.target.value)} className="w-full border px-3 py-2 rounded" />
        </div>

        <div>
          <label className="block font-semibold">Role</label>
          <input type="text" value={role} disabled onChange={(e) => setRole(e.target.value)} className="w-full border px-3 py-2 rounded" />
        </div>

        <div>
          <label className="block font-semibold">Status (is_confirm)</label>
          <select value={isConfirm} onChange={(e) => setIsConfirm(Number(e.target.value) as 0 | 1)} className="w-full border px-3 py-2 rounded">
            <option value={1}>Aktif</option>
            <option value={0}>Tidak Aktif</option>
          </select>
        </div>

        <div>
          <label className="block font-semibold">Foto Profile</label>
          <input type="file" accept="image/*" onChange={(e) => setFotoProfile(e.target.files?.[0] || null)} />
          {admin.foto_profile && <img src={admin.foto_profile} alt={admin.name} className="w-32 h-32 object-cover rounded mt-2" />}
        </div>

        <div>
          <label className="block font-semibold">Foto KTP</label>
          <input type="file" accept="image/*" onChange={(e) => setFotoKtp(e.target.files?.[0] || null)} />
          {admin.foto_ktp && <img src={admin.foto_ktp} alt="Foto KTP" className="w-32 h-32 object-cover rounded mt-2" />}
        </div>

        <div>
          <label className="block font-semibold">Foto ID Card</label>
          <input type="file" accept="image/*" onChange={(e) => setFotoIdcard(e.target.files?.[0] || null)} />
          {admin.foto_idcard && <img src={admin.foto_idcard} alt="Foto ID Card" className="w-32 h-32 object-cover rounded mt-2" />}
        </div>

        <div className="flex justify-between mt-4">
          <button type="submit" className="bg-primary text-white px-4 py-2 rounded">
            Simpan Perubahan
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminStafDetail;
